module.exports = __webpack_public_path__ + "media/file2.mp4";